'use client'
import { getCookie } from 'typescript-cookie'
import { ConfirmCode } from '../Models/ConfirmCode';

// Part of this validation is currently not useful. In the future if this app is put in distributed system the confirmCodeObj will come
// from a caching tool like Redis instead of passed as a parameter.  ex: - enteredConfirmCode --> cached confirm code / id <-- cookie id
const ValidateConfirmCode = async (confirmCodeObj: ConfirmCode, enteredConfirmCode: string): Promise<boolean> => {
    var sentConfirmCodeId = getCookie(`${process.env.CASH_OUT_CONFIRM_CODE}`)

    if (sentConfirmCodeId === confirmCodeObj.id && 
        enteredConfirmCode === confirmCodeObj.value) {
        return new Promise<boolean>((resolve) => {
            resolve(true);
        });
    }
    else {
        return new Promise<boolean>((resolve) => {
            resolve(false);
        });
    }
}

export default ValidateConfirmCode;